module.exports = __webpack_public_path__ + "img/top2.65e044a4.png";